import { IProduct } from './types';

export const getProductPathname = (product: IProduct) => {
  const { id, slug } = product;
  return slug ? `/produto/${id}/${slug}?` : `/produto/${id}?`;
};
